export default "__VITE_ASSET__CEO2DduO__"